import React, { useRef, useContext, useState } from "react";
import { Tour, Space } from 'antd';
import language from "../../resources/languages/fa_IR";
import { ActionType, Enum } from "./../../resources/constants";

// Contexts
import GlobalContext from '../../contexts/global';

// Components
import Control from './control';
import Direction from './direction';
import NeshanMap from './neshan-map';
import Preloader from '../preloader'
import FilterButton from '../filter/button'
import SupportButton from '../support/button'
import RequestButton from '../request/button'
import Menu from '../menu'
import Travel from '../travel'
import Drawer from '../drawer'

const { SET_OPEN_TOUR, SET_FORM, SET_OPEN_DRAWER } = ActionType
const { Form } = Enum
const { Share } = language

export default function Index() {

    const { openTour, dispatch} = useContext(GlobalContext)
    const [loaded, setLoaded] = useState<boolean>(true)
    const [L, setL] = useState<any>(null)
    const [map, setMap] = useState<any>(null)
    const tour = useRef(null)

    return loaded ? (
        <>
            <NeshanMap
                style={{
                    width: '100%',
                    height: '100vh'
                }}
                options={{
                    maptype: 'dreamy',
                    poi: true,
                    traffic: false,
                    zoomControl: false,
                    center: [Number(process.env.REACT_APP_LAT), Number(process.env.REACT_APP_LNG)],
                    zoom: 5
                }}
                onInit={(L: any, myMap?: any) => {
                    setLoaded(true)
                    setL(L)
                    setMap(myMap)
                }}
            >
                {
                    L && map && (
                        <>
                        <Control L={L} map={map} position={'topleft'} className={'leaflet-control-top-left'}>
                            <Travel />
                            <Direction L={L} map={map} />
                        </Control>
                            <Control L={L} map={map} position={'topright'} className={'leaflet-control-top-right'}>
                                <Drawer />
                            </Control>
                            <Control L={L} map={map} position={'bottomright'} className={'leaflet-control-bottom-right'}>
                                <Menu />
                            </Control>
                            <Control L={L} map={map} position={'bottomleft'} className={'leaflet-control-bottom-left'}>
                               <Space className={'btn-bottom-left'} size={13}>
                                   <SupportButton />
                                   <RequestButton />
                                   <FilterButton tour={tour} />
                               </Space>
                            </Control>
                         <Tour
                             open={openTour}
                             placement={'topRight'}
                             className={'tour-filter'}
                             closeIcon={false}
                             onClose={() => {
                                 dispatch({ type: SET_OPEN_TOUR , payload: { openTour: false }})
                                 dispatch({ type: SET_FORM , payload: { form: Form.FILTER }})
                                 dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
                             }}
                             zIndex={10001}
                             steps={[{title: Share.tour, target: () => tour.current}]}
                         />
                        </>
                    )
                }
            </NeshanMap>
        </>
    ) : <Preloader />;
}
